export default "/_next/static/images/5535059e925f26bc625439b31e9f7b06.png";